import { render, staticRenderFns } from "./DocumentsSecureList.vue?vue&type=template&id=ed6d639a&scoped=true&"
import script from "./DocumentsSecureList.vue?vue&type=script&lang=js&"
export * from "./DocumentsSecureList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsSecureList.vue?vue&type=style&index=0&id=ed6d639a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6d639a",
  null
  
)

export default component.exports